import { dmApi } from "../dmApi";
import { handleQueryErrorAndSuccess } from "../../helpers/RtkQueryUtils";
import { getAuthorizationHeader } from "../../helpers/RtkQueryUtils";
const surveryCategoryApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        createSurveCategory: build.mutation({
            query: ({ formData }) => ({
                url: '/admin/create-survey-categories',
                method: "POST",
                body: formData,
                headers: getAuthorizationHeader()
            }),
            invalidatesTags: ['categoryListApi'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, '', 'Survey assigned successfully');
            },
        }),
        updateSurveCategory: build.mutation({
            query: ({ surveyCategoryId, body }) => ({

                url: `/admin/update-survey-category?surveyCategoryId=${surveyCategoryId}`,
                method: 'PUT',
                body,
                headers: getAuthorizationHeader()
            }),
            invalidatesTags: ['categoryListApi','getAllSurveyCategoriesIdApi'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, '', 'Survey assigned successfully');
            },
        }),
        getAllSurveyCategories: build.query({
            query: ({ page = 1, search = "", limit = 10 }) => ({
                url: `admin/survey-all-categories?page=${page}&limit=${limit}&search=${search}`,
                method: "GEt",
                headers: getAuthorizationHeader()
            }),
            providesTags : ['categoryListApi']
        }),
        getAllSurveyCategoriesId: build.query({
            query: ({ surveyCategoryId }) => ({
                url: `admin/survey-category-by-id?surveyCategoryId=${surveyCategoryId}`,
                method: "GEt",
                headers: getAuthorizationHeader()
            }),
             providesTags : ['getAllSurveyCategoriesIdApi']
        })
    })
})
export const { useCreateSurveCategoryMutation, useUpdateSurveCategoryMutation, useGetAllSurveyCategoriesQuery, useGetAllSurveyCategoriesIdQuery } = surveryCategoryApi